var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._b({attrs:{"type":"tel","pattern":"\\(\\d{2}\\) 9\\d{4}-\\d{4}","maxlength":"15"},domProps:{"value":_vm.phone},on:{"input":_vm.mask,"change":_vm.transforma}},'input',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }